import { GOLDEN_RATIO, size } from '@geom';

export const LayoutConstants = {
  // The padding around the graph when zooming to fit.
  PAN_ZOOM_REVEAL_PADDING: 30,
  // The padding around the graph when exporting to SVG or other formats.
  EXPORT_PADDING: 30,
  // The padding around the title of a unit.
  UNIT_TITLE_PADDING: 10,
  // The minimum size of a unit.
  UNIT_MIN_SIZE: size(50, 50),
  // The icon size of a unit.
  UNIT_ICON_SIZE: size(32, 32),
  // The gap between the icon and the text in a unit.
  UNIT_ICON_GAP: 8,
  // The padding around the title of a group.
  GROUP_TITLE_PADDING: 10,
  // The width of the stroke around a hovered group.
  HOVERED_GROUP_STROKE_WIDTH: 2,
  // The padding around the child nodes in a group.
  GROUP_CONTENT_PADDING: 40,
  // The minimum width of a unit title.
  UNIT_MIN_TITLE_WIDTH: 30,
  // The maximum width of a group title.
  GROUP_MAX_TITLE_WIDTH: 800,
  // The default target aspect ratio of a node.
  DEFAULT_NODE_ASPECT_RATIO: GOLDEN_RATIO,
  // The minimum gap between node edges in a relative placement constraint.
  RELATIVE_PLACEMENT_CONSTRAINT_GAP: 100,
  // How close nodes have to be to be considered overlapping.
  NODE_OVERLAP_MARGIN: 20,
  // The amount of space around nodes to be considered when routing edges.
  EDGE_ROUTING_MARGIN: 20,
  // The corner radius of a node.
  NODE_CORNER_RADIUS: 5,
  // The corner radius of a group.
  GROUP_CORNER_RADIUS: 0,
  // The width of the stroke around a node.
  NODE_STROKE_WIDTH: 2,
  // The width of the stroke around a node indicator.
  NODE_CREATION_INDICATOR_STROKE_WIDTH: 2,
  // The width of the stroke around a hovered node.
  HOVERED_NODE_STROKE_WIDTH: 3,
  // The width of the stroke along an edge.
  EDGE_WIDTH: 2,
  // The expansion of the edge halo around a hovered edge.
  HOVERED_EDGE_EXPAND: 0.5,
  // The farthest distance from an edge to be considered hovered.
  HOVERED_EDGE_MAX_DISTANCE: 10,
  // The width of the highlight around a selected graph element.
  SELECTION_HALO_WIDTH: 4,
  // The opacity of and edge endpoint highlight marker.
  ENDPOINT_HIGHLIGHT_OPACITY: 0.8,
  // The radius of an edge endpoint highlight marker.
  ENDPOINT_HIGHTLIGHT_RADIUS: 8,
  // The gap between two nodes in a gap inequality constraint.
  EDGE_INEQUALITY_CONSTRAINT_GAP: 80
};
